<div class="col-10 mt-4 d-flex eu-column justify-content-center">
    <div class="table__container">
        @if (!isPromoStoneConditions()) {
            <table class="m-4">
                <tr class="mdr-table__row">
                    <td class="mdr-table__brand-th"></td>
                    <th class="mdr-table-th" scope="col">DÉBITO</th>
                    <th class="mdr-table-th" scope="col">CRÉDITO<br />À VISTA</th>
                    <th class="mdr-table-th" scope="col">CRÉDITO<br />2X A 6X</th>
                    <th class="mdr-table-th" scope="col">CRÉDITO<br />7X A 12X</th>
                </tr>

                <tr class="mdr-table__row">
                    <th class="mdr-table__brand-th" scope="row">
                        <img class="mdr-table-img" src="assets/mastercard-48px.png" alt="master" />
                    </th>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().mastercard.debit | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().mastercard.credit | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().mastercard.psj1 | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().mastercard.psj2 | percent: '1.2-2') : 0 }}
                    </td>
                </tr>

                <tr class="mdr-table__row">
                    <th class="mdr-table__brand-th" scope="row">
                        <img class="mdr-table-img" src="assets/visa-48px.png" alt="visa" />
                    </th>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().visa.debit | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().visa.credit | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().visa.psj1 | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().visa.psj2 | percent: '1.2-2') : 0 }}
                    </td>
                </tr>

                <tr class="mdr-table__row">
                    <th class="mdr-table__brand-th" scope="row">
                        <img class="mdr-table-img" src="assets/elo-48px.png" alt="elo" />
                    </th>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().elo.debit | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().elo.credit | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().elo.psj1 | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().elo.psj2 | percent: '1.2-2') : 0 }}
                    </td>
                </tr>

                <tr class="mdr-table__row">
                    <th class="mdr-table__brand-th" scope="row">
                        <img class="mdr-table-img" src="assets/hipercard-48px.png" alt="hiper" />
                    </th>
                    <td class="mdr-table-td">-</td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().hipercard.credit | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().hipercard.psj1 | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().hipercard.psj2 | percent: '1.2-2') : 0 }}
                    </td>
                </tr>

                <tr class="mdr-table__row border-0">
                    <th class="mdr-table__brand-th" scope="row">
                        <img class="mdr-table-img" src="assets/amex-48px.png" alt="amex" />
                    </th>
                    <td class="mdr-table-td">-</td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().american_express.credit | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().american_express.psj1 | percent: '1.2-2') : 0 }}
                    </td>
                    <td class="mdr-table-td">
                        {{ mdr() ? (mdr().american_express.psj2 | percent: '1.2-2') : 0 }}
                    </td>
                </tr>
            </table>
        } @else {
            <table class="m-4">
                <tr class="mdr-table__row">
                    <th class="mdr-table__brand-th">
                        <div class="eu-display_flex eu-column">
                            <img
                                class="mdr-table-img"
                                src="assets/mastercard-48px.png"
                                alt="master"
                            />
                            <img class="mdr-table-img" src="assets/visa-48px.png" alt="visa" />
                        </div>
                    </th>
                    <th class="mdr-table-th" scope="col">DÉBITO</th>
                    <th class="mdr-table-th" scope="col">CRÉDITO<br />À VISTA</th>
                    <th class="mdr-table-th" scope="col">CRÉDITO<br />2X A 6X</th>
                    <th class="mdr-table-th" scope="col">CRÉDITO<br />7X A 12X</th>
                </tr>

                <tr class="mdr-table__row">
                    <td>
                        <span class="emd-text _type_bold _size_section">Bateu Meta</span>
                    </td>
                    <td class="mdr-table-td">
                        {{ promoStoneFees().hitGoal.debit / 100 | percent: '1.2-2' }}
                    </td>
                    <td class="mdr-table-td">
                        {{ promoStoneFees().hitGoal.credit / 100 | percent: '1.2-2' }}
                    </td>
                    <td class="mdr-table-td">
                        {{ promoStoneFees().hitGoal.psj1 / 100 | percent: '1.2-2' }}
                    </td>
                    <td class="mdr-table-td">
                        {{ promoStoneFees().hitGoal.psj2 / 100 | percent: '1.2-2' }}
                    </td>
                </tr>

                <tr class="mdr-table__row border-0">
                    <td>
                        <span class="emd-text _type_bold _size_section"> Não Bateu Meta</span>
                    </td>
                    <td class="mdr-table-td">
                        {{ promoStoneFees().didntReachGoal.debit / 100 | percent: '1.2-2' }}
                    </td>
                    <td class="mdr-table-td">
                        {{ promoStoneFees().didntReachGoal.credit / 100 | percent: '1.2-2' }}
                    </td>
                    <td class="mdr-table-td">
                        {{ promoStoneFees().didntReachGoal.psj1 / 100 | percent: '1.2-2' }}
                    </td>
                    <td class="mdr-table-td">
                        {{ promoStoneFees().didntReachGoal.psj2 / 100 | percent: '1.2-2' }}
                    </td>
                </tr>
            </table>
        }
    </div>

    @if (isDailyPayment()) {
        <div class="info-tag mt-5">
            <i class="fa fa-info-circle _color_subtle"></i>
            <span class="emd-text _size-info">
                A antecipação para o mesmo dia está sujeita a aprovação, sendo reprovada o cliente
                será cadastrado com as condições de recebimento de no próximo dia.
            </span>
        </div>
    }
</div>
